var AUI_PREFIX = 'asurion-ui';
export var randomId = function (prefix) {
    return "".concat(AUI_PREFIX, "-").concat(prefix, "-").concat(Math.random().toString(36).substr(2, 9));
};
